"use client";

import { memo, type ReactNode } from "react";

export interface StoreConsumerProps<T> {
  children: (store: T) => ReactNode;
}

export function createAtomConsumer<T>(
  storeName: string,
  useStore: (scope?: string) => T
): React.FC<StoreConsumerProps<T>> {
  const StoreConsumer = (props: StoreConsumerProps<T>): ReactNode => {
    const store = useStore();

    return props.children(store);
  };

  StoreConsumer.displayName = `${storeName}AtomConsumer`;

  return memo(StoreConsumer);
}
